import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const MEMBER_API_URL = `${API_HOST}/api/member`;

function* createMember() {
  yield takeEvery(actions.CREATE_MEMBER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MEMBER_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_ENDED });
    }
  });
}

function* lockMember() {
  yield takeEvery(actions.LOCK_MEMBER, function* (action) {
    const { memberId, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${MEMBER_API_URL}/${memberId}/lock`, null);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.LOCK_MEMBER_ENDED });
    }
  });
}

function* unlockMember() {
  yield takeEvery(actions.UNLOCK_MEMBER, function* (action) {
    const { memberId, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${MEMBER_API_URL}/${memberId}/unlock`, null);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UNLOCK_MEMBER_ENDED });
    }
  });
}

function* deactivateMember() {
  yield takeEvery(actions.DEACTIVATE_MEMBER, function* (action) {
    const { memberId, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${MEMBER_API_URL}/${memberId}/deactivation`, null);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DEACTIVATE_MEMBER_ENDED });
    }
  });
}

function* searchMembers() {
  yield takeEvery(actions.SEARCH_MEMBERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MEMBER_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBERS_ENDED });
    }
  });
}

function* findMember() {
  yield takeEvery(actions.FIND_MEMBER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MEMBER_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MEMBER_ENDED });
    }
  });
}

function* updateMember() {
  yield takeEvery(actions.UPDATE_MEMBER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MEMBER_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_ENDED });
    }
  });
}

function* getMembershipLevelOfMember() {
  yield takeEvery(actions.GET_MEMBERSHIP_LEVEL_OF_MEMBER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MEMBER_API_URL}/${id}/level`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_MEMBERSHIP_LEVEL_OF_MEMBER_ENDED });
    }
  });
}

function* getTagOfMember() {
  yield takeEvery(actions.GET_TAG_OF_MEMBER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MEMBER_API_URL}/${id}/tag`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_TAG_OF_MEMBER_ENDED });
    }
  });
}

function* getMemberPointBalanceOfMember() {
  yield takeEvery(actions.GET_MEMBER_POINT_BALANCE_OF_MEMBER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MEMBER_API_URL}/${id}/point`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_MEMBER_POINT_BALANCE_OF_MEMBER_ENDED });
    }
  });
}

function* adjustMembershipLevel() {
  yield takeEvery(actions.ADJUST_MEMBERSHIP_LEVEL, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${API_HOST}/api/membershipLevel/record/transition`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.ADJUST_MEMBERSHIP_LEVEL_ENDED });
    }
  });
}

function* searchMemberAttributes() {
  yield takeEvery(actions.SEARCH_MEMBER_ATTRIBUTES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/member/attribute?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_ATTRIBUTES_ENDED });
    }
  });
}

function* findMemberAttribute() {
  yield takeEvery(actions.FIND_MEMBER_ATTRIBUTE, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/member/attribute/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MEMBER_ATTRIBUTE_ENDED });
    }
  });
}

function* updateMemberAttribute() {
  yield takeEvery(actions.UPDATE_MEMBER_ATTRIBUTE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/member/attribute`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_ATTRIBUTE_ENDED });
    }
  });
}

function* unmaskProfile() {
  yield takeEvery(actions.UNMASK_PROFILE, function* (action) {
    const { memberId, data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${API_HOST}/api/member/${memberId}/unmaskProfile`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UNMASK_PROFILE_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMember),
    fork(lockMember),
    fork(unlockMember),
    fork(deactivateMember),
    fork(searchMembers),
    fork(findMember),
    fork(updateMember),
    fork(getMembershipLevelOfMember),
    fork(getTagOfMember),
    fork(getMemberPointBalanceOfMember),
    fork(adjustMembershipLevel),
    fork(searchMemberAttributes),
    fork(findMemberAttribute),
    fork(updateMemberAttribute),
    fork(unmaskProfile),
  ]);
}
